<div class="home">
    <h1>Bienvenue sur l’interface BackOffice de Hub4B.</h1>
    <br />
    <br />
    <br />
    <h1>Paramétrage de l'organisation : {{ selectedOrganizationDisplayName }}</h1>
</div>
